"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var R = _interopRequireWildcard(require("ramda"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _Button = _interopRequireWildcard(require("../../../../../ui/Button"));
var _Input = _interopRequireDefault(require("../../../../../ui/Input"));
var _Textarea = _interopRequireDefault(require("../../../../../ui/Textarea"));
var _Select = _interopRequireDefault(require("../../../../../ui/Select"));
var _Checkbox = _interopRequireDefault(require("../../../../../ui/Checkbox"));
var _Alert = _interopRequireWildcard(require("../../../../../ui/Alert"));
var _selectors = require("../../../../store/selectors");
var _config = require("../../../../../../services/config");
var _helpers = require("../../helpers");
var _Claim = require("../Claim");
var _withFormProps = _interopRequireDefault(require("./withFormProps"));
var _styles = _interopRequireDefault(require("./styles"));
var _constants = require("./constants");
var _SaveBasketToClaimButton = _interopRequireDefault(require("./components/SaveBasketToClaimButton"));
var _DeleteButton = _interopRequireDefault(require("./components/DeleteButton"));
var _ToggleBasketStatus = _interopRequireDefault(require("./components/ToggleBasketStatus"));
var _selectors2 = require("./store/selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var EditForm = function EditForm(_ref) {
  var basketID = _ref.basketID,
    isActiveSubmitButton = _ref.isActiveSubmitButton,
    _ref$isShowSuccessMes = _ref.isShowSuccessMessage,
    isShowSuccessMessage = _ref$isShowSuccessMes === void 0 ? false : _ref$isShowSuccessMes,
    loading = _ref.loading,
    onChangeDiscount = _ref.onChangeDiscount,
    onSubmit = _ref.onSubmit,
    onChangeMargin = _ref.onChangeMargin,
    onChangeShowPriceWithMargin = _ref.onChangeShowPriceWithMargin,
    onChangeRound = _ref.onChangeRound;
  var _useTranslation = (0, _reactI18next.useTranslation)('BASKET_EDIT_FORM'),
    t = _useTranslation.t;
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors.getBasketById)(state, {
        basketID: basketID
      });
    }),
    claim = _useSelector.claim;
  var templates = (0, _reactRedux.useSelector)(_selectors.getBasketTemplates);
  var getIsEnabledMarginCheckboxSelector = (0, _react.useMemo)(function () {
    return (0, _selectors2.getIsEnabledMarginCheckbox)(basketID);
  }, [basketID]);
  var isEnabledMarginCheckbox = (0, _reactRedux.useSelector)(getIsEnabledMarginCheckboxSelector);
  var offersReviewsLinks = (0, _reactRedux.useSelector)(_selectors.getOffersReviewsLinks);
  var onGetOffersReviewsLinks = (0, _config.getOnGetOffersReviewsLinks)();
  return /*#__PURE__*/_react.default.createElement("form", {
    className: _styles.default.formContainer,
    onSubmit: onSubmit
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.formWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.formTitle
  }, t('FORM_TITLE')), claim ? /*#__PURE__*/_react.default.createElement(_Claim.Claim, {
    description: claim.claimDesc,
    claimID: claim.id,
    link: claim.claimLink,
    basketID: basketID,
    isEnabledRemove: true
  }) : /*#__PURE__*/_react.default.createElement(_SaveBasketToClaimButton.default, {
    basketID: basketID
  }), /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: _constants.FORM_FIELDS.TITLE,
    render: function render(_ref2) {
      var field = _ref2.field,
        form = _ref2.form;
      var errorMsg = (0, _formik.getIn)(form, "touched.".concat(field.name)) && (0, _formik.getIn)(form, "errors.".concat(field.name));
      return /*#__PURE__*/_react.default.createElement(_Input.default, _extends({}, field, {
        errorMsg: errorMsg,
        hasError: Boolean(errorMsg),
        className: _styles.default.formStyle,
        label: t('NAME_CONTROL_LABEL'),
        onChange: function onChange(_, event) {
          field.onChange(event);
        }
      }));
    }
  }), /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: _constants.FORM_FIELDS.COMMENT,
    render: function render(_ref3) {
      var field = _ref3.field;
      return /*#__PURE__*/_react.default.createElement(_Textarea.default, _extends({}, field, {
        className: _styles.default.formStyle,
        id: field.name,
        label: t('COMMENT_CONTROL_LABEL'),
        onChange: function onChange(_, event) {
          field.onChange(event);
        }
      }));
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.formRow
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.formCol
  }, /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: _constants.FORM_FIELDS.TEMPLATE,
    render: function render(_ref4) {
      var field = _ref4.field,
        form = _ref4.form;
      return /*#__PURE__*/_react.default.createElement(_Select.default, {
        className: _styles.default.formSelect,
        items: templates,
        label: t('TEMPLATE_CONTROL_LABEL'),
        value: field.value,
        onChange: function onChange(nextManagerID) {
          form.setFieldValue(field.name, nextManagerID);
          form.setFieldTouched(field.name, true);
        }
      });
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.formCol
  }, /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: _constants.FORM_FIELDS.LOCALE,
    render: function render(_ref5) {
      var field = _ref5.field,
        form = _ref5.form;
      return /*#__PURE__*/_react.default.createElement(_Select.default, {
        className: _styles.default.formSelect,
        items: _constants.LANGUAGES_OPTIONS,
        label: t('LOCALE_CONTROL_LABEL'),
        value: field.value,
        onChange: function onChange(locale) {
          form.setFieldValue(field.name, locale);
          form.setFieldTouched(field.name, true);
        }
      });
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.formRow
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.formCol
  }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
    name: _constants.FORM_FIELDS.DISCOUNT,
    render: function render(_ref6) {
      var field = _ref6.field,
        form = _ref6.form;
      return /*#__PURE__*/_react.default.createElement(_Input.default, _extends({}, field, {
        className: _styles.default.formStyle,
        label: t('DISCOUNT_CONTROL_LABEL'),
        onChange: function onChange(discount) {
          var proccessDiscountValue = (0, _helpers.handleComma)(discount);
          try {
            (0, _helpers.validateValueAsNumber)(proccessDiscountValue);
            form.setFieldValue(field.name, proccessDiscountValue);
            onChangeDiscount(proccessDiscountValue);
            var shouldHidePriceWithMargin = R.and(!Number(proccessDiscountValue), !Number(form.values[_constants.FORM_FIELDS.MARGIN]));
            if (shouldHidePriceWithMargin) {
              form.setFieldValue(_constants.FORM_FIELDS.SHOW_PRICE_WITH_MARGIN, false);
            }
          } catch (error) {
            // ignore error
          }
        }
      }));
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.formCol
  }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
    name: _constants.FORM_FIELDS.MARGIN,
    render: function render(_ref7) {
      var field = _ref7.field,
        form = _ref7.form;
      return /*#__PURE__*/_react.default.createElement(_Input.default, _extends({}, field, {
        className: _styles.default.formStyle,
        label: t('MARGIN_CONTROL_LABEL'),
        onChange: function onChange(margin) {
          var proccessMarginValue = (0, _helpers.handleComma)(margin);
          try {
            (0, _helpers.validateValueAsNumber)(proccessMarginValue);
            form.setFieldValue(field.name, proccessMarginValue);
            onChangeMargin(proccessMarginValue);
            var shouldHidePriceWithMargin = R.and(!Number(proccessMarginValue), !Number(form.values[_constants.FORM_FIELDS.DISCOUNT]));
            if (shouldHidePriceWithMargin) {
              form.setFieldValue(_constants.FORM_FIELDS.SHOW_PRICE_WITH_MARGIN, false);
            }
          } catch (error) {
            // ignore error
          }
        }
      }));
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.formRow
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.formCol
  }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
    name: _constants.FORM_FIELDS.SHOW_PRICE_WITH_MARGIN,
    render: function render(_ref8) {
      var field = _ref8.field,
        form = _ref8.form;
      var errorMsg = (0, _formik.getIn)(form, "touched.".concat(field.name)) && (0, _formik.getIn)(form, "errors.".concat(field.name));
      var isDisabledMarginCheckbox = R.or(isEnabledMarginCheckbox, form.values.round) ? false : !form.values.discount && !form.values.margin;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _styles.default.checkboxTitle
      }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        checked: field.value,
        disabled: isDisabledMarginCheckbox,
        errorMsg: errorMsg,
        hasError: Boolean(errorMsg),
        label: t('SHOW_PRICE_WITH_MARGIN_LABEL'),
        onChange: function onChange(value) {
          onChangeShowPriceWithMargin(value);
          form.setFieldValue(field.name, value);
          form.setFieldTouched(field.name, true);
        }
      }));
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.formCol
  }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
    name: _constants.FORM_FIELDS.ROUND,
    render: function render(_ref9) {
      var field = _ref9.field,
        form = _ref9.form;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _styles.default.checkboxTitle
      }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        checked: field.value,
        label: t('ROUND_PRICES_LABEL'),
        onChange: function onChange(value) {
          onChangeRound(value);
          form.setFieldValue(field.name, value);
          form.setFieldTouched(field.name, true);
          var shouldHidePriceWithMargin = R.and(!Number(form.values[_constants.FORM_FIELDS.MARGIN]), !Number(form.values[_constants.FORM_FIELDS.DISCOUNT]));
          if (shouldHidePriceWithMargin) {
            form.setFieldValue(_constants.FORM_FIELDS.SHOW_PRICE_WITH_MARGIN, false);
          }
        }
      }));
    }
  }))), onGetOffersReviewsLinks && /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: _constants.FORM_FIELDS.OFFERS_REVIEWS_LINK,
    render: function render(_ref0) {
      var field = _ref0.field,
        form = _ref0.form;
      return /*#__PURE__*/_react.default.createElement(_Select.default, {
        className: _styles.default.offersReviewControl,
        itemClassName: _styles.default.selectItem,
        items: offersReviewsLinks,
        label: t('OFFERS_REVIEWS_LINK_CONTROL_LABEL'),
        value: field.value,
        onChange: function onChange(urlType) {
          form.setFieldValue(field.name, urlType);
          form.setFieldTouched(field.name, true);
        }
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: _constants.FORM_FIELDS.RATING,
    render: function render(_ref1) {
      var field = _ref1.field,
        form = _ref1.form;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _styles.default.checkboxTitle
      }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        checked: field.value,
        label: t('RATING_CONTROL_LABEL'),
        onChange: function onChange(value) {
          form.setFieldValue(field.name, value);
          form.setFieldTouched(field.name, true);
        }
      }));
    }
  }), isShowSuccessMessage && /*#__PURE__*/_react.default.createElement(_Alert.default, {
    className: _styles.default.success,
    type: _Alert.TYPES.SUCCESS
  }, t('SUCCESS_SAVED_ALERT')), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.formButtons
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    loading: loading,
    className: _styles.default.saveButton,
    theme: isActiveSubmitButton ? _Button.THEMES.PURPLE : _Button.THEMES.GRAY,
    type: "submit"
  }, t('SAVE_BUTTON')), /*#__PURE__*/_react.default.createElement(_ToggleBasketStatus.default, {
    basketID: basketID
  }), /*#__PURE__*/_react.default.createElement(_DeleteButton.default, {
    basketID: basketID
  }))));
};
var enhancer = R.compose(_withFormProps.default, _react.memo);
EditForm.propTypes = {
  basketID: _propTypes.default.number.isRequired,
  isActiveSubmitButton: _propTypes.default.bool.isRequired,
  isShowSuccessMessage: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  onChangeDiscount: _propTypes.default.func.isRequired,
  onChangeShowPriceWithMargin: _propTypes.default.func.isRequired,
  onChangeMargin: _propTypes.default.func.isRequired,
  onSubmit: _propTypes.default.func.isRequired,
  onChangeRound: _propTypes.default.func.isRequired
};
var _default = exports.default = enhancer(EditForm);